import { ApplicationState, AppThunkDispatch, AppThunkAction } from "../../store";
import { connect } from "react-redux";
import Profile, { ProfileStateProps, ProfileDispatchProps } from "./Profile";
import { getMyUser } from "../../store/entities/usersSelectors";
import { UserEntity, EntityType, Entity, ProfessionalEntity } from "../../store/entities/state";
import { updateChangingEntity, updateEntity } from "../../store/entities/actions";
import { updateMeAsync, updateMeProfessionalAsync, sendConfirmationEmailAsync } from "../../ajax/requests";
import { isSubmitting, getEntity, getChangingValue, getChangingState } from "../../store/entities/selectors";
import { alertSuccess, alertGenericError } from "../../store/alerts/actions";
import { TK } from "../../store/translations/translationKeys";
import { loggedUserIsClient, getMyUser as getSessionUser } from "../../store/session/selectors";
import { translate } from "../../store/translations/hooks";
import { updateSessionUser } from "../../store/session/actions";
import { UpdateUserData } from "../../models/api-models";

const updateUserRequest = (data: Entity): Promise<void> => {
    const userEntity = data as UserEntity & { password?: string };
    const updateData: UpdateUserData = {
        id: userEntity.id,
        password: userEntity.password || undefined,
        email: userEntity.email,
        permissions: userEntity.permissions,
        professionalId: userEntity.professionalId,
        name: userEntity.name,
        photoFileId: userEntity.photoFileId,
        mfa: userEntity.mfa,
        mfaPhoneNumber: userEntity.mfaPhoneNumber,
        defaultCashRegisterName: userEntity.defaultCashRegisterName,
    };
    return updateMeAsync(updateData);
};

const updateProfessionalRequest = (data: Entity) => updateMeProfessionalAsync(data as ProfessionalEntity);

const sendConfirmationEmail = (): AppThunkAction<Promise<void>>  => {
    return async (dispatch, getState) => {
        try {
            await sendConfirmationEmailAsync();
            dispatch(alertSuccess(translate(TK.confirmationEmailSent)));
        } catch(error) {
            dispatch(alertGenericError());
        }
    }
}

const mapStateToProps = (state: ApplicationState): ProfileStateProps => {
    const myUser = getMyUser(state);
    const sessionUser = getSessionUser(state);
    const myProfessional = myUser?.professionalId ? getEntity<ProfessionalEntity>(state, 'professionals', myUser?.professionalId) : undefined;
    return {
        user: getChangingValue(state, 'users') as UserEntity || myUser || sessionUser || { id: 'ERROR', username: 'ERROR', permissions: [] },
        isClient: loggedUserIsClient(state),
        professional: getChangingValue(state, 'professionals') as ProfessionalEntity || myProfessional,
        isSubmittingUser: myUser && isSubmitting('users')(state) ? true : false,
        isSubmittingProfessional: myProfessional && isSubmitting('professionals')(state) ? true : false,
        userHasChanged: getChangingState(state, 'users'),
        professionalHasChanged: getChangingState(state, 'professionals'),
    };
}

const mapDispatchToProps = (dispatch: AppThunkDispatch): ProfileDispatchProps => ({
    userChange: (data: UserEntity) => dispatch(updateChangingEntity('users', data)),
    professionalChange: (data: ProfessionalEntity) => dispatch(updateChangingEntity('professionals', data)),
    submitUserEdition: (data: UserEntity) => dispatch(updateEntity('users', data, updateUserRequest))
        .then(() => {
            dispatch(updateSessionUser({
                name: data.name,
                email: data.email,
                photoUrl: data.photoUrl,
                identitySource: data.identitySource,
                defaultCashRegisterName: data.defaultCashRegisterName,
            }));
            dispatch(alertSuccess(translate(TK.savedSuccessfully)));
        }),
    submitProfessionalEdition: (data: ProfessionalEntity) => dispatch(updateEntity('professionals', data, updateProfessionalRequest)),
    sendConfirmationEmail: () => dispatch(sendConfirmationEmail()),
});

export default connect<ProfileStateProps, ProfileDispatchProps, void, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(Profile as any);
